// This is use during development stage only. To remove once all component completed.

import { Button } from '@nextgen-web-framework/all';
import { useSelector } from 'react-redux';
import type { AppState } from '@nextgen-web-framework/core';

export interface RegistrationDummyProps {
  nextHandler: () => void;
}

const RegistrationFallback = ({ nextHandler }: RegistrationDummyProps) => {
  const { stepName } = useSelector((state: AppState) => state.commerceProfile.registrationFlowData);
  return (
    <div data-testid="registration-dummy-step">
      Dummy Step: {stepName}
      <Button onClick={() => nextHandler()} title="Next" data-testid="registration-dummy-step-button" />
    </div>
  );
};

export default RegistrationFallback;
